import { RegistrationComponent } from './../registration/registration.component';
import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MustMatch } from '../../core/validators/must-match.validator';
import { AuthenticationService } from '../../services';
import { BuyerService } from '../../services/buyer.service';
import { BannerService } from '../../services/banner.service';
import { AuctionService } from '../../services/auction.service';
import { AnnouncementService } from '../../services/announcement.service';
import { Banner, Announcement } from '../../models';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import routeTable from '../../utility/routeTable';
import messages from '../../utility/messages';
import constants from '../../utility/constants';
import { CurrentAuctionList } from '../../models/auctionList';
import {
  ConstantContactService,
  MailingList,
} from '../../services/constant-contact.service';
import { AppValidators } from '../../core/validators/app-validators';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-public-home',
  templateUrl: './public-home.component.html',
  styleUrls: ['./public-home.component.css'],
  providers: [RegistrationComponent],
  encapsulation: ViewEncapsulation.None,
})
export class PublicHomeComponent implements OnInit {
  banners: Banner[];
  upcomingAuctions: CurrentAuctionList[] = [];
  upcomingMachineryAuctions: CurrentAuctionList[] = [];
  featuredPastAuctions: CurrentAuctionList[] = [];
  announcement: Announcement = null;
  routes: any;
  private subscriptions: Array<Subscription> = [];

  bannerAlignments = constants.common.bannerAlignment;
  displaySections = constants.common.displaySection;
  auctionStatuses = constants.common.auctionStatus;

  createForm: FormGroup;
  //Minimum eight characters, at least one uppercase letter, one lowercase letter and one number:
  patternHign: any = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d@$!%*?&]{8,}$';
  warehouseSlider = {
    infinite: true,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  featuredPastSlider = {
    infinite: true,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  awardsSlider = {
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  homeBannerSlider = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    pauseOnHover: true,
  };

  loading: boolean = false;

  constructor(
    private modalService: BsModalService,
    public modalRef: BsModalRef,
    private buyerService: BuyerService,
    private toastr: ToastrService,
    public formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private bannerService: BannerService,
    private auctionService: AuctionService,
    private announcementService: AnnouncementService,
    private constantContact: ConstantContactService
  ) {
    this.routes = routeTable.public;
  }

  ngOnInit(): void {
    this.createForm = this.formBuilder.group(
      {
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
        mobileNumber: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.maxLength(12),
        ]),
        company: new FormControl(''),
        street: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        country: new FormControl('', Validators.required),
        state: new FormControl('', Validators.required),
        postalCode: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.maxLength(12),
          ])
        ),
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(this.patternHign),
          ])
        ),
        confirmPassword: new FormControl('', Validators.required),
      },
      {
        validators: MustMatch('password', 'confirmPassword'),
      }
    );

    this.route.params.subscribe((params) => {
      if (this.router.url.split('/')[1] == 'activate') {
        let hash = params['token'];
        const activate = this.buyerService.activate(hash).subscribe(
          () => {
            this.toastr.success(
              messages.publicHome.activated,
              constants.common.toast.successTitle,
              constants.common.toast.config
            );
            this.router.navigate(['']);
          },
          (error) => {
            this.toastr.error(
              error,
              constants.common.toast.errorTitle,
              constants.common.toast.config
            );
          }
        );
        this.subscriptions.push(activate)
      }
      if (this.router.url.split('/')[1] == 'user-reset-password') {
        let modalOptions: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          class: 'custom-popup user-login modal-dialog modal-dialog-centered',
        };
        let hash = params['token'];
        const validatePwd = this.authenticationService
          .validatePasswordLink(hash)
          .subscribe((res) => {
            if (res.data == true) {
              this.router.navigate(['']);
              this.modalRef = this.modalService.show(
                ResetPasswordComponent,
                modalOptions
              );
              this.modalRef.content = hash;
            } else {
              this.toastr.error(
                'Reset password link has expired',
                constants.common.toast.errorTitle,
                constants.common.toast.config
              );
              this.router.navigate(['']);
            }
          });
          this.subscriptions.push(validatePwd)
      }
    });

    this.getBannerSettings();
    this.getUpcomingAuctions();
    this.getUpcomingMachineryAuctions();
    this.getFeaturedPastAuctions();
    this.getAnnoucement();
  }

  private getBannerSettings() {
    const randomizedSetting = this.bannerService.getRandomizeSetting().subscribe((res) => {
      this.getBanners(res);
    });
    this.subscriptions.push(randomizedSetting)
  }

  private getBanners(isRandomize: boolean) {
    const bannerCarousal = this.bannerService.getBannersCarousel().subscribe((response) => {
      this.banners = isRandomize ? this.shuffle(response) : response;
    });
    this.subscriptions.push(bannerCarousal)
  }

  private shuffle(array: Array<Banner>): Array<Banner> {
    if (array.length > 1) {
      for (let index = array.length - 1; index > 0; index--) {
        let randomIndex = Math.floor(Math.random() * (index + 1)); // random index from 0 to index
        [array[index], array[randomIndex]] = [array[randomIndex], array[index]]; // destructuring the array fro swapping elements
      }
    }
    return array;
  }

  private getUpcomingAuctions() {
    let pagingModel = {
      auctionStatus: this.auctionStatuses.LiveUpcomingFeatured,
      displaySection: [
        this.displaySections.auctionCalender,
        this.displaySections.turnKey,
      ],
      pageNumber: 1,
      pageSize: 6,
      isPaginated: true,
    };

    const allCurrentAuction = this.auctionService
      .getAllCurrentAuctions(pagingModel)
      .subscribe((response) => (this.upcomingAuctions = response.data));
      this.subscriptions.push(allCurrentAuction)
  }

  private getUpcomingMachineryAuctions() {
    let pagingModel = {
      auctionStatus: this.auctionStatuses.LiveUpcomingFeatured,
      displaySection: [this.displaySections.machinery],
      isPaginated: false,
    };

    const allCurrentAuctions = this.auctionService
      .getAllCurrentAuctions(pagingModel)
      .subscribe((response: any) => {
        this.upcomingMachineryAuctions = response.data;
      });
      this.subscriptions.push(allCurrentAuctions)
  }

  private getFeaturedPastAuctions() {
    let pagingModel = {
      auctionStatus: this.auctionStatuses.featuredPast,
      displaySection: [...this.displaySections.featuredPast],
      isPaginated: false,
      pageSize: 18
    };

    const allCurrentAuctions = this.auctionService
      .getAllCurrentAuctions(pagingModel)
      .subscribe((response: any) => {
        this.featuredPastAuctions = response.data;
      });
      this.subscriptions.push(allCurrentAuctions)
  }

  getAnnoucement() {
    const announcement = this.announcementService
      .getAnnouncements()
      .subscribe((response) => (this.announcement = response));
      this.subscriptions.push(announcement)
  }

  hideAndReset() {
    this.modalRef.hide();
    this.createForm.reset();
  }

  goToRegister(route: string, auctionId: number) {
    this.router.navigate([route, auctionId, 'register'], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  maxlengthShorter: number = constants.common.validations.maxLength50;
  emailSubscription: FormControl = new FormControl(null, [
    Validators.required,
    AppValidators.checkEmail,
    Validators.maxLength(this.maxlengthShorter),
  ]);
  mailingList: Array<MailingList>;
  selectedMailList: Array<string> = [];

  config = {
    ignoreBackdropClick: true,
    class: 'custom-popup modal-dialog modal-dialog-centered subscribe-popup',
  };

  openModal(template: TemplateRef<any>) {
    let ccHtml = document.getElementById('cc-subscribeform');
    let inputEmail = document.getElementById('sub-home-input');
    const clone = ccHtml.cloneNode(true) as HTMLElement;
    let inputs = clone.getElementsByClassName("ctct-form-element");
    [].forEach.call(inputs, x => {
      //@ts-ignore
      x.value = inputEmail.value;
    })
    clone.removeAttribute('style');
    clone.setAttribute('style', 'display: block;')
    this.modalRef = this.modalService.show(template, this.config);
    let subscribeModalBody = document.getElementById('subscribeModal-body-home');
    subscribeModalBody.appendChild(clone);
  }

  closeModal() {
    let ccHtml = document.getElementById('cc-subscribeform');
    const clone = ccHtml.cloneNode(true) as HTMLElement;
    clone.removeAttribute('style');
    clone.setAttribute('style', 'display: none;')
    if (this.modalRef) this.modalRef.hide();
  }

  checkItem(isChecked: boolean, listId: string) {
    if (isChecked) this.selectedMailList.push(listId);
    else
      this.selectedMailList.splice(
        this.selectedMailList.findIndex((i) => i === listId),
        1
      );
  }

  subscribe() {
    this.loading = true;
    const subscribeListing = this.constantContact
      .subscribeToListing(this.emailSubscription.value, this.selectedMailList)
      .subscribe(
        (res: any) => {
          if (res) this.closeModal();
          this.selectedMailList = [];
          this.toastr.success(
            'You can unsubscribe at any time using the Unsubscribe link at the bottom of every email.',
            'Thanks for signing up!',
            constants.common.toast.config
          );
          this.loading = false;
          this.emailSubscription.reset();
        },
        (err) => {
          this.loading = false;
        }
      );
      this.subscriptions.push(subscribeListing)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
